export const DEFAULT_PAGINATION_DATA = {
  currentPage: 1,
  itemsPerPage: 10,
  count: 10,
  lastPage: 0,
};

export const DEFAULT_SORT_BY = {
  order: 'ASC',
  column: 'firstName',
};
